/**
 * The one approved company logo. Used everywhere a logo appears across the
 * app — printed documents, the central gateway, and the in-app sidebar —
 * for every business (KMG and Murudeshwara both use this same asset, by
 * instruction; this is intentionally NOT per-business). Changing the logo
 * for everyone means replacing this one file (and, if the new asset isn't a
 * square, adjusting the few `object-contain` boxes that show it).
 */
export const COMPANY_LOGO_SRC = '/branding/kmg-temple-stones-logo.jpg'
